/** Pointer-centred wheel zoom and drag-to-pan; Shift preserves text selection. */
export const pdfPointerNavigation = {
    wheelZoom(event) {
        if (!this._application || event.deltaY === 0) return;
        const units = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.$refs.container.clientHeight : 1;
        this._wheelDelta = (this._wheelDelta || 0) + event.deltaY * units;
        this._wheelOrigin = [event.clientX, event.clientY];
        if (this._wheelFrame) return;
        this._wheelFrame = window.requestAnimationFrame(() => {
            this._wheelFrame = null;
            const factor = Math.exp(-Math.max(-400, Math.min(400, this._wheelDelta)) * 0.002);
            this._wheelDelta = 0;
            this._viewer?.updateScale({ scaleFactor: factor, origin: this._wheelOrigin, drawingDelay: 100 });
        });
    },
    startPan(event) {
        if (this.panEnabled === false || event.button !== 0 || event.shiftKey || event.target.closest('a,button,input,textarea,.work-pdf-markup')) return;
        const node = this.$refs.container;
        if (node.scrollWidth <= node.clientWidth && node.scrollHeight <= node.clientHeight + 1) return;
        event.preventDefault();
        node.setPointerCapture(event.pointerId);
        this._pan = { x: event.clientX, y: event.clientY, left: node.scrollLeft, top: node.scrollTop };
        node.classList.add("work-pdf-document__scroll--dragging");
    },
    movePan(event) {
        if (!this._pan) return;
        const node = this.$refs.container;
        node.scrollLeft = this._pan.left + this._pan.x - event.clientX;
        node.scrollTop = this._pan.top + this._pan.y - event.clientY;
    },
    endPan() { this._pan = null; this.$refs.container?.classList?.remove("work-pdf-document__scroll--dragging"); },
};
